export const BACKEND_URL = 'https://martinhanak.com/en/api'